import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompaniesService } from '../../../services/companies.service';
import { ProductService } from '../../../services/product.service';
import { OwnerService } from '../../../services/billing-letter/owner.service';
import { Owner } from '../../../models/billing-letter/Owner.model';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { Router } from '@angular/router';
import { ToastsManager } from "ng2-toastr";
import { HashtrackService } from "../../../services/hashTrack.service";
import { AwsService } from '../../../services/aws.service';
import { BankService } from '../../../services/bank.service';
import { ExternalReferenceFinancial } from '../../../models/ExternalReference.model';
import { GUARDS } from '../../../shared/auth/Roles';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
// import * as moment from 'moment';
import * as _ from 'lodash';
// import { CompanyContract } from '../../../models/CompanyContract.model';
// import { PixKeyType } from '../../../shared/enums/PixKeyType';
import { CompanyService } from '../../../services/billing-letter/company.service';
// import { PixValidation } from '../../../shared/helpers/PixValidation';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { Industry } from '../../../models/Industry.model';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { Responsible } from '../../../models/Responsible.model';
import { IndustriesService } from '../../../services/industries.service';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { UserService } from '../../../services/user.service';
import { CnaeService } from '../../../services/cnae.service';
import { SapItemType } from '../../../shared/enums/SapItemType';


@Component({
  selector: 'app-companie-create',
  templateUrl: './companie-create.component.html',
  styleUrls: ['./companie-create.component.css']
})
export class CompanieCreateComponent implements OnInit {
  @ViewChild('uploadInput') uploadInput:ElementRef;
  hashCustomers;
  emails: string[];
  name: string;
  companyForm: FormGroup;
  cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
  mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
  accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
  agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
  digitMask = [/[A-Za-z0-9]/];
  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  contractNotificationPattern = /([A-Za-z ])|[^\w\s]/gi;
  numberPattern = [/[0-9]/,'.',/[0-9]/,/[0-9]/];
  company: Company = new Company();
  commonHelper: CommonHelper = new CommonHelper();
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companyGroupSearchModel: CompanyGroupSearch;
  DropDownHash;
  DropDownSettings;
  selectedHash;
  loading: boolean;
  selectedFiles:FileList;
  managers: Owner[] = [];

  banks : any = [];
//   pixKeyVerifyMethod : any;
//   pixKeyFlag: Boolean = true;
//   pixCpfValid : Boolean;
//   pixCnpjValid : Boolean;
  phoneMaskFlag: Boolean = false;
  textMask;
  industries: Industry[] = new Array<Industry>();
  excellenceCenters: ExcellenceCenter[] = new Array<ExcellenceCenter>();
  responsibles: Responsible[] = new Array<Responsible>();
  restCaracters: number


  canSave: Boolean = true;
  allowedRoles = [GUARDS.MANAGER, GUARDS.JUDICIARY, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.DP, GUARDS.BILLSRECEIVE];
  user;

  items = [];
  itemsDropdown = {
    list: [],
    options: null,
    selected: []
  };
  readjustmentQuoeficient: any[] = [];

  constructor(private companiesService: CompaniesService,
    private companyService: CompanyService,
    private productService: ProductService,
    private ownerService: OwnerService,
    private localStorage: LocalStorage,
    private formBuilder: FormBuilder,
    private dropDownItemFactory: DropdownItemFactory,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private router: Router,
    private tostr: ToastsManager,
    private awsService: AwsService,
    private industriesService: IndustriesService,
    private excellenceCentersService: ExcellenceCentersService,
    private userService: UserService,
    private hashtrackService: HashtrackService,
    private bankService: BankService,
    // public pixValidation: PixValidation,
    private errorHandler: ErrorHandlerProvider,
    private cnaeService: CnaeService
  ) { }

  async ngOnInit() {

    this.loading = true;
    this.textMask = {mask: false}
    this.companyForm = this.formBuilder.group({
      name: [null, Validators.required],
      companyName: [null, Validators.required],
      companyGroup: [null, [this.validateSelectOption]],
      industry: [null, [this.validateSelectOptionIndustries]],
      cnpj: [null, [Validators.required, Validators.pattern(this.cnpjPattern)]],
      emails: [null, Validators.required],
    //   keyPix:[null, [this.validateKeyPix]],
    });

    this.company.isCustomer = false;
    this.checkPermissions();

    this.hashCustomers = await this.hashtrackService.getAllCustomers();
    this.DropDownHash = this.commonHelper.getDropDownListItems(this.hashCustomers, "_id", "name");
    this.DropDownSettings = this.commonHelper.getDropDownSettings(true, "Cliente", false, "", "", true,null, "");


    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.industries = await this.industriesService.getAll();
    this.excellenceCenters = await this.excellenceCentersService.getAll();
    this.responsibles = await this.userService.getActiveUsers();
    this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
    this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);
    this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:false,enableCheckAll:false});
    this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});

    this.managers = await this.ownerService.getActiveUsers();

    this.banks = await this.bankService.getBanks();
    this.company.purchaseRecurring = false;
    this.setValidIsCustomer(this.company.isCustomer);
    this.loading = false;
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
        this.company.isCustomer = false;
    }
  }

  setValidIsCustomer(toggleValue) {
    if(toggleValue) {
        this.companyForm.get("companyGroup").enable();
        this.companyForm.get("industry").enable();
    } else {
        this.companyForm.get("companyGroup").disable();
        this.companyForm.get("industry").disable();
    }
    this.selectedFiles = null;
    if(this.uploadInput)
        this.uploadInput.nativeElement.value = '';
  }

  async OnSave() {
    try {

        // if(!this.company.payment.keyPix && this.company.payment.typePix != 0){
        //     this.tostr.warning("A chave pix é obrigatória")
        //     return;
        //     }

        if (this.companyForm.valid) {

            if(this.company.companyName.length > 100)
                return this.tostr.warning('O nome da empresa é longo demais, permitido apenas 100 caracteres!');

            if (this.selectedHash && this.selectedHash.length > 0) {
                this.company.externalReference = new ExternalReferenceFinancial();
                this.company.externalReference._id = this.selectedHash[0].id;
                this.company.externalReference.name = this.selectedHash[0].itemName;
            } else
                this.company.externalReference = null;

            if(this.company.companyGroup._id != '' && this.company.companyGroup._id != undefined)
                this.company.companyGroup.name = this.companyGroups.find(x => x._id === this.company.companyGroup._id).name;

            if(this.company.industry)
                this.company.industry = this.industries.find(x => x._id === this.company.industry._id);

            if(!this.company.isCustomer && this.itemsDropdown.selected.length > 0){
                const itemsSelected = this.itemsDropdown.selected.map(item => {
                    return item.sapItemCode;
                });
                this.company.defaultItems = itemsSelected;
            }

            this.loading = true;
            let response = await this.companiesService.create(this.company);
            if(response._id){
                this.loading = false;
                if(this.selectedFiles){
                    this.upload(response._id);
                }
                this.tostr.success('Empresa criada com sucesso!');
                if(this.company.isCustomer)
                    this.router.navigate(['/companies']);
                else
                    this.router.navigate(['/purchase-orders']);
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response, 'Empresa');
            }
        }

    } catch(err){
        this.loading = false;
        this.errorHandler.interceptError(err, 'Empresa');
    }
  }

  OnClear() {
    this.company = new Company();
    this.uploadInput.nativeElement.value = '';
  }

  verifyValidTouched(fieldName) {
    return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
  }

  validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' || !control.value)
            return {valid: true};
        return null;
  }

  validateSelectOptionIndustries(control: AbstractControl) {
    if (!control.value || control.value == "")
    return {valid: true};

    return null;
}

//   trim(){
//     if(this.company.payment.keyPix)
//         this.company.payment.keyPix = this.company.payment.keyPix.trim();
//   }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

  verifyDate(date,field){
    if(!(new RegExp(this.datePattern).test(date))){
        this.tostr.warning(`Digite uma data válida.`,"Data inválida!");
        this.company[`${field}`] = "";
    }
  }

  verifyContractNotificationValue(value, field){
      if(value <= 0 || new RegExp(this.contractNotificationPattern).test(value)){
          this.tostr.warning(`Valor para o lembrete de encerramento de contrato
          não pode ser negativo, valor padrão será atribuído`, "Valor inválido!");
          this.company[`${field}`] = 30;
      }
  }

  async verifyCNPJ(){
    if(this.company.cnpj == '' || this.company.cnpj == undefined) {
        this.tostr.warning('CNPJ não pode ser vazio');
    } else {
      let response = await this.companiesService.verifyCnpj(this.company);
      if(response.length > 0){
        this.tostr.warning(
            `O CNPJ está cadastrado para o ${this.company.isCustomer ? 'cliente' : 'fornecedor'} ${response[0].name?response[0].name:""}`,
            'CNPJ em uso!'
        );
        this.company.cnpj = '';
        this.company.name = '';
        this.company.companyName = '';
      } else {
        await this.cnpjSearch();
      }
    }
  }

  async cnpjSearch(){
      try {
        let cnpj = this.company.cnpj;
        if(cnpj == '')
            return this.tostr.warning('CNPJ não pode ser vazio!');
        if(!this.companiesService.cnpjValid(cnpj))
            return this.tostr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

        this.tostr.warning('Realizando consulta ao CNPJ...');
        cnpj = cnpj.trim();

        let response = await this.companiesService.getCnpj(this.company.cnpj);
        if(response.success) {
            this.company.name = response.fantasia;
            this.company.companyName = response.nome;
            this.company.address.street = response.logradouro;
            this.company.address.number = response.numero;
            this.company.address.complement = response.complemento;
            this.company.address.city = response.municipio;
            this.company.address.uf = response.uf;
            this.company.address.district = response.bairro;
            this.company.address.zipCode = response.cep;
            this.company.address.type = response.tipo;
        } else {
            this.errorHandler.interceptError(response, 'Empresa');
        }
      } catch(err) {
        this.errorHandler.interceptError(err, 'Empresa');
      }
  }

//   async verifyCPFCNPJPixKey(){
//     if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
//         this.tostr.warning("O CPF/CNPJ é obrigatório!");
//         this.company.payment.keyPix = "";
//     } else if(this.commonHelper.cpfValidator(this.company.payment.keyPix)){
//         this.pixCpfValid = true;
//     } else if(this.companiesService.cnpjValid(this.company.payment.keyPix)){
//       this.pixCnpjValid = true;
//     }else if(!this.pixCnpjValid && !this.pixCpfValid){
//       this.tostr.warning('CPF/CNPJ inválido.');
//       this.company.payment.keyPix = "";
//     }
//   }

    cnpjValid(cnpj: String) {
        return this.companiesService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.companiesService.getCnpj(cnpj);
    }

    // randomPixKeySearch(){
    //     if(this.company.payment.keyPix == '' || this.company.payment.keyPix == undefined) {
    //         this.tostr.warning('Aleatório não pode ser vazio');
    //     } else if (!this.companyService.randomPixKeyValid(this.company.payment.keyPix)) {
    //         this.tostr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
    //         this.company.payment.keyPix = ''
    //     }
    // }

    // async verifyEmailPixKey(){
    //     this.trim();

    //     if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
    //     this.tostr.warning("O Email é obrigatório!");
    //     this.company.payment.keyPix = "";
    //     }else{
    //         if (!(new RegExp(this.emailPattern).test((this.company.payment.keyPix).toString()))) {
    //             this.tostr.warning(`Digite um email válido.`, "Email inválido!");
    //             this.company.payment.keyPix = "";
    //         }
    //     }
    // }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    upload(id) {
        let length = this.selectedFiles.length;
        for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
        this.awsService.uploadfile(file,id);
        }
    }

    emailBlur() {
      this.tostr.warning('Aperte ENTER para confirmar a inserção do e-mail');
    }

    // onPixTypeChange() {
    //     this.pixValidation.onPixTypeChange(this.company.payment.typePix, this.companyForm.get("keyPix"))
    //     this.textMask = {mask: false}
    // }

    // async verifyPixKey(){
    //     if (!this.company.payment.typePix) {
    //         return
    //     }
    //     this.pixCpfValid = false;
    //     this.pixCnpjValid = false;

    //     let typePix = this.company.payment.typePix

    //     switch (typePix) {
    //         case PixKeyType.phone:
    //             if(!this.commonHelper.phoneNumberValidator(this.company.payment.keyPix)){
    //                 this.tostr.warning('CPF/CNPJ inválido.');
    //                 this.company.payment.keyPix = "";
    //             }
    //             break;
    //         case PixKeyType.email:
    //             this.verifyEmailPixKey();
    //             break;
    //         case PixKeyType.cpf_cnpj:
    //             this.verifyCPFCNPJPixKey();
    //             break;
    //         case PixKeyType.randomized:
    //             this.randomPixKeySearch();
    //             break;
    //         default:
    //             break;
    //     }
    // }

    // onChangeMask() {
    //     let typePix = this.company.payment.typePix;
    //     switch (typePix) {
    //         case PixKeyType.phone:
    //             this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
    //             break;
    //         case PixKeyType.cpf_cnpj:
    //             let inputValue = this.company.payment.keyPix;
    //             if(!inputValue) return;

    //             if (inputValue && inputValue.length > 14)
    //                 this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
    //             else
    //                 this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
    //             break;
    //         case PixKeyType.randomized:
    //             this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
    //             break;
    //         default:
    //             break;
    //     }
    // }

    // validateKeyPix(control: AbstractControl){
    //     if(!control.value) return {keyPix:true}
    //         return null;
    // }

    validateLimitCaracters(limit: number, inputWord: string) {
        let strLength = inputWord.length
        this.restCaracters = limit

        while (this.restCaracters > 0) {
            this.restCaracters = this.restCaracters - strLength

            break
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/views/companies/companie-create/companie-create.component.ts